import React, { useEffect, useState } from 'react';
import "firebase/storage";

const GameLeaderBox = (props) => {
  const { item, avatar, app, teamId } = props; // `teamId` identifies the player's team
  const [avatarPlayer, setAvatarPlayer] = useState();

  useEffect(() => {
    if (app?.firebaseApp) {
      const fetchAvatar = async () => {
        try {
          // Try fetching the player's avatar
          const playerAvatar = await app.firebaseApp
            .storage()
            .ref(`Player/${item.id}/profile.png`)
            .getDownloadURL();
          setAvatarPlayer(playerAvatar);
        } catch (error) {
          try {
            // If player avatar is unavailable, fetch the team's avatar
            const teamAvatar = await app.firebaseApp
              .storage()
              .ref(`Team/${teamId}/profile.png`)
              .getDownloadURL();
            setAvatarPlayer(teamAvatar);
          } catch (teamError) {
            // If both fail, fall back to the default avatar
            setAvatarPlayer(avatar);
          }
        }
      };

      fetchAvatar();
    }
  }, [app?.firebaseApp, item.id, teamId, avatar]);

  return (
    <div className="leader-player-container">
      {/* Player or Team Avatar */}
      <div
        className="avatar"
        style={{ backgroundImage: `url(${avatarPlayer})` }}
      ></div>

      {/* Player Details */}
      <div className="player-detail">
        <div className="player-name">
          #{item?.number} {item?.name}
        </div>

        {/* Player Stats */}
        <div className="player-stats">
          {/* Points */}
          <div className="stats-wrapper">
            <div className="point">
              <div align="center">
                <strong>
                  {item?.["1g"] +
                    2 * item?.["2g"] +
                    3 * item?.["3g"] +
                    2 * item?.["2t"] +
                    3 * item?.["3t"] +
                    2 * item?.["2c"] +
                    3 * item?.["3c"]}
                </strong>
              </div>
              <div className="stat">
                <strong>
                  <font color="gray">PTS</font>
                </strong>
              </div>
            </div>
          </div>

          {/* Field Goals */}
          <div className="stats-wrapper">
            <div className="point">
              <div align="center">
                <strong>
                  {item?.["2g"] +
                    item?.["3g"] +
                    item?.["2t"] +
                    item?.["3t"] +
                    item?.["2c"] +
                    item?.["3c"]}{" "}
                  -{" "}
                  {item?.["2g"] +
                    item?.["3g"] +
                    item?.["2t"] +
                    item?.["3t"] +
                    item?.["2c"] +
                    item?.["3c"] +
                    item?.["2m"] +
                    item?.["3m"]}
                </strong>
              </div>
              <div className="stat">
                <strong>
                  <font color="gray">FG</font>
                </strong>
              </div>
            </div>
          </div>

          {/* Rebounds */}
          <div className="stats-wrapper">
            <div className="point">
              <strong>{item?.["or"] + item?.["r"]}</strong>
            </div>
            <div className="stat">
              <strong>
                <font color="gray">REB</font>
              </strong>
            </div>
          </div>

          {/* Assists */}
          <div className="stats-wrapper">
            <div className="point">
              <strong>{item?.["a"] + item?.["2gr"] + item?.["3gr"]}</strong>
            </div>
            <div className="stat">
              <strong>
                <font color="gray">AST</font>
              </strong>
            </div>
          </div>

          {/* Steals */}
          <div className="stats-wrapper">
            <div className="point">
              <strong>{item?.["s"]}</strong>
            </div>
            <div className="stat">
              <strong>
                <font color="gray">STL</font>
              </strong>
            </div>
          </div>

          {/* Turnovers */}
          <div className="stats-wrapper">
            <div className="point">
              <strong>{item?.["t"]}</strong>
            </div>
            <div className="stat">
              <strong>
                <font color="gray">TO</font>
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameLeaderBox;
